import { render } from "./inventoryheadertab.vue?vue&type=template&id=16b5b524&scoped=true"
import script from "./inventoryheadertab.vue?vue&type=script&lang=js"
export * from "./inventoryheadertab.vue?vue&type=script&lang=js"

import "./inventoryheadertab.vue?vue&type=style&index=0&id=16b5b524&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b5b524"]])

export default __exports__